export enum SharedItemShareType {
  ExternalFolderShare = 'external_folder_share',
  ExternalShare = 'external_share'
}
